<template>
  <v-container>
    <v-radio-group v-model="selected" row>
      <v-radio  v-for="( item) in vouchers" class="my-12 mx-10 d-block" :value="item.id">
        <template slot="label">
          <c-card :title="item.voucherId.name" style="width: 400px">
            <div> 소유자 : {{item.customerId.name}}</div>
            <div> 남은개수 : {{ item.remainCnt}} </div>
            <div> 만료일 : {{ item.expirationDate}} </div>
            <div> 발급기관 :{{item.voucherId.organization}}</div>
          </c-card>
        </template>
      </v-radio>
    </v-radio-group>

  </v-container>
</template>

<script>
  export default {
    props: {
      customerData: {
        type: Object
      },
      voucherState: {
        type: String
      }
    },
    data() {
      return {
        customer : null,
        selected : '',
        vouchers : [],

      }
    },
    watch : {
      customerData(val){
        if(val) {
          this.customer = val;
          this.reqVoucherList();
          this.selected = this.voucherState;
        }
      },
      selected(val) {
        this.onSelectVoucherState(val);
      }
    },
    mounted() {
    },
    methods : {
      async reqVoucherList() {
        // 예약자가 속한 그룹의 모든 바우처
        const res = await this.$api.getGroupVoucherState(this.customer.id);
        this.vouchers = res.data;
      },
      onSelectVoucherState(voucherStateId) {
        this.$emit('update:voucherState', voucherStateId);
      }
    }
  }
</script>

<style scoped>

</style>